module.exports = __webpack_public_path__ + "media/images/sale-1-f2d17709.jpg";